<template>
  <div class="hello">
    <div class="subTitle">雅安天立高中</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'yatlgz',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=qrNnmFAR6Gd8f37edaf21f4373OJZbEtuO9Rbtm0hF6+j1BciimiUgqey6iMNZXgebjsS9PXbQ3AIqLBlAWRaa6L+AaolFYWJXSxmBvzNDY8fzSqRx0+1QrXBK2vKmTD73YHZ4/LTdJ6rzbX'
        },
        {
          label: '素养费',
          url: 'https://common-cspay.cibfintech.com/?data=qrNnmFAR6Gd8f37edaf21f4373OJZbEtuO9RbtIXLyfcMUmpFhZBCWchyvtq04reY/aQcSy52cAfwxz9z7hw4+dWFfjRZaG9NCyw/iGn+xuw5YrONH7ZrbdhxO/TPJJ8ElV1JE5RXLZ4MSEG'
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM8p02AT2+Wab9W+xfn7RFx6fyGfO1PplN6gkIH5lgsNUATwGLUIiYBGh+jX00mxma0wZ2IrNJumOnfSf/r27YdJUpAIA4kTojiH2gGgEadgeSMPDgYmHxWVjdmEaFwmwAfP4ra6Aihy4r+Ogn5EBaCk='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '雅安天立高中';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

